import { useEffect } from 'react';
export default (function (_ref) {
  var id = _ref.id,
    onClickOutside = _ref.onClickOutside,
    onClickInside = _ref.onClickInside,
    exceptionID = _ref.exceptionID;
  useEffect(function () {
    var listener = function listener(e) {
      if ($(e.target).closest("#".concat(id, ",#").concat(exceptionID)).length === 0 && onClickOutside) onClickOutside(e);else if (onClickInside) onClickInside(e);
    };
    $(document).on('click', listener);
    return function () {
      return $(document).off('click', listener);
    };
  }, []);
});